<template>
  <div class="main-wrap">
    <div class="loader" v-if="this.showLoadingModal === true">
      <div class="loader__bar"></div>
      <div class="loader__bar loader__bar--delay-1"></div>
      <div class="loader__bar loader__bar--delay-2"></div>
      <div class="loader__bar loader__bar--delay-3"></div>
      <div class="loader__bar loader__bar--delay-4"></div>
      <div class="loader__bar loader__bar--delay-5"></div>
    </div>

    <section class="moveup" v-if="this.showLoadingModal === false && $screen.width > 576">
      <Scroll-Div width="98%" height="85vh" view-class="yourclassname" v-if="this.showLoadingModal === false">
        <div class="container mt-4">


          <div class="modal-box">
            <div class="mdialog" role="document">
              <div class="modal-content clearfix">
                <div class="modal-body">
                  <div class="row align-items-center justify-content-center">
                    <div class="col-12 align-items-center">
                      <img src="../../public/icons/electronic-farm.svg" width="50%"
                           alt="Breed Gallinas"/>
                    </div>
                  </div>
                  <div class="row align-items-center justify-content-center mt-4">
                    <div class="col-8 align-items-center dark-text-section">
                      <h3 class="title">Start your own Gallina farm!</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div v-if="$screen.width >= 992" class="modal-box mt-4">
            <div class="mdialog" role="document">
              <div class="modal-content clearfix">
                <div class="modal-body">
                  <div class="row align-items-center justify-content-evenly">
                    <div class="col-4 d-flex align-items-center justify-content-evenly">
                      <img src="../../public/icons/buy-eggs-infograph.svg" width="150px"
                           alt="Breed Gallinas"/>
                    </div>
                    <div class="col-6 align-items-center justify-content-evenly dark-text-section p-5">
                      <h3 class="title">Hatch Eggs</h3>
                      <br/>
                      <p class="description small-font-3d">Each Egg hatches into a collectable NFT Gallina on the Kadena Blockchain with it's own DNA!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="$screen.width >= 992" class="modal-box mt-4">
            <div class="mdialog" role="document">
              <div class="modal-content clearfix">
                <div class="modal-body">
                  <div class="row align-items-center justify-content-evenly">
                    <div class="col-4 d-flex align-items-center justify-content-evenly">
                      <img src="../../public/icons/farm-chickens-infograph.svg" width="180px"
                           alt="Breed Gallinas"/>
                    </div>
                    <div class="col-6 align-items-center justify-content-evenly dark-text-section p-5">
                      <h3 class="title">Farm Gallinas</h3>
                      <br/>
                      <p class="description small-font-3d">Breed and trade your Gallinas with friends and unlock newer Gallina traits!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="$screen.width >= 992" class="row mt-4 frontfooter justify-content-lg-evenly">
            <div class="col-4">
              <div class="modal-box">
                <div class="mdialog" role="document">
                  <div class="modal-content clearfix">
                    <div class="modal-body" style="padding:20px;">
                      <h3 class="title" style="position:relative; right:0px;">{{ this.getGameTotalGallinas() }} <img
                          src="../../public/icons/chicken-mygallinas-icon.svg" alt="Gallinas" width="40px"></h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="modal-box">
                <div class="mdialog" role="document">
                  <div class="modal-content clearfix">
                    <div class="modal-body" style="padding:20px;">
                      <h3 class="title" style="position:relative; right:0px;">{{ this.getGameTotalEggs() }} <img
                          src="../../public/icons/egg-mygallinas-icon.svg" alt="Eggs" width="30px"></h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-box mt-4">
            <div class="mdialog" role="document">
              <div class="modal-content clearfix">
                <div class="modal-body">
                  <div class="row align-items-center justify-content-evenly">

                    <div class="col-6 d-flex align-items-center justify-content-evenly">
                      <FlipCard name="Rosey" id="03" :ishomepage="true"
                                gender="Female" birthday="01-01-2022" nbd="01-02-2022"
                                motherid="01" fatherid="02" :showbuttons="false" :showinspectbutton="false"
                                extra11="0" extra12="0"
                                generation="0"
                                rarity="1"
                                :useexpand="false"
                                :setcount="this.getGameTotalGallinas().toString()"
                                gene1h1="1" gene2h1="0" gene3h1="0" gene4h1="1" gene5h1="1" gene6h1="1" gene7h1="1"
                                gene8h1="1" gene9h1="1" gene10h1="1" gene11h1="1" gene12h1="1"
                                gene1h2="1" gene2h2="0" gene3h2="1" gene4h2="1" gene5h2="1" gene6h2="1" gene7h2="1"
                                gene8h2="1" gene9h2="1" gene10h2="1" gene11h2="1" gene12h2="1"
                                gene1h3="1" gene2h3="0" gene3h3="1" gene4h3="0" gene5h3="1" gene6h3="1" gene7h3="1"
                                gene8h3="1" gene9h3="1" gene10h3="1" gene11h3="1" gene12h3="2"
                                beak="1" belly="1" chest="1" comb="1" eyes="1" feet="1" head="1" legs="1" wattle="1"
                                wings="1">
                      </FlipCard>
                    </div>
                    <div v-if="$screen.width > 1200" class="col-6 d-flex align-items-center justify-content-evenly">
                      <div class="paper">
                        <div class="lines">
                          <div class="text">
                            My Gallina Notes
                            <br/><br/><br/>
                            Gallinas seem to come in all shapes, sizes and colors!
                            <br/>
                            <br/>
                            Gallina traits come directly from their DNA!
                            <br/>
                            <br/>
                            When I breed my Gallinas, their DNA mixes, producing new traits and new Gallinas!
                            <br/>
                            <br/>
                            I love my Gallinas!
                          </div>
                        </div>
                        <div class="holes hole-top"></div>
                        <div class="holes hole-middle"></div>
                        <div class="holes hole-bottom"></div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="$screen.width >= 992 && this.getAccountConfirmed() === true" class="modal-box mt-4">
            <div class="mdialog" role="document">
              <div class="modal-content clearfix">
                <div class="modal-body">
                  <div class="row align-items-center justify-content-evenly">
                    <div class="col-10 align-items-center justify-content-evenly dark-text-section p-5 pt-4">
                      <h3 class="title mt-0">DNA Records</h3>
                      <p class="description small-font-3d">Show me records for set:</p>  <v-suggest class="gallinacansearch"
                                                                                                    :data="gallinaSetSearchList"
                                                                                                    :full-list="true" placeholder="Pick a Set" @values="searchtovalue"
                    ></v-suggest> <button type="button" class="mx-3 btnsearch" style="position:relative; top: 4px; outline:none;"
                                          @click="clickSearch1()">
                      <div v-if="searching === true" class="loadereye">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span v-if="searching === false">Search</span>
                    </button>
                      <br/>
                      <br/>

                      <div v-if="searched === true" class="row justify-content-center align-items-center">
                        <div class="col indexfont">Gene</div>
                      </div>

                      <div v-if="searched === true" class="row">
                        <div class="col-1" style="width:40px;"><div class="geneindex indexfont">Trait</div></div>
                        <div class="col">

                          <table class="comicGreen">
                            <thead>
                            <tr>
                              <th></th>
                              <th> 0</th>
                              <th> 1</th>
                              <th> 2</th>
                              <th> 3</th>
                              <th> 4</th>
                              <th> 5</th>
                              <th> 6</th>
                              <th> 7</th>
                              <th> 8</th>
                              <th> 9</th>
                              <th> 10</th>
                              <th> 11</th>
                              <th> 12</th>
                              <th> 13</th>
                              <th> 14</th>
                              <th> 15</th>
                              <th> 16</th>
                              <th> 17</th>
                              <th> 18</th>
                              <th> 19</th>
                              <th> 20</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <th>Beak</th>
                              <td>{{ this.gallinaDNAList[0][0] }}</td>
                              <td>{{ this.gallinaDNAList[1][0] }}</td>
                              <td>{{ this.gallinaDNAList[2][0] }}</td>
                              <td>{{ this.gallinaDNAList[3][0] }}</td>
                              <td>{{ this.gallinaDNAList[4][0] }}</td>
                              <td>{{ this.gallinaDNAList[5][0] }}</td>
                              <td>{{ this.gallinaDNAList[6][0] }}</td>
                              <td>{{ this.gallinaDNAList[7][0] }}</td>
                              <td>{{ this.gallinaDNAList[8][0] }}</td>
                              <td>{{ this.gallinaDNAList[9][0] }}</td>
                              <td>{{ this.gallinaDNAList[10][0] }}</td>
                              <td>{{ this.gallinaDNAList[11][0] }}</td>
                              <td>{{ this.gallinaDNAList[12][0] }}</td>
                              <td>{{ this.gallinaDNAList[13][0] }}</td>
                              <td>{{ this.gallinaDNAList[14][0] }}</td>
                              <td>{{ this.gallinaDNAList[15][0] }}</td>
                              <td>{{ this.gallinaDNAList[16][0] }}</td>
                              <td>{{ this.gallinaDNAList[17][0] }}</td>
                              <td>{{ this.gallinaDNAList[18][0] }}</td>
                              <td>{{ this.gallinaDNAList[19][0] }}</td>
                              <td>{{ this.gallinaDNAList[20][0] }}</td>
                            </tr>
                            <tr>
                              <th>Belly</th>
                              <td>{{ this.gallinaDNAList[0][1] }}</td>
                              <td>{{ this.gallinaDNAList[1][1] }}</td>
                              <td>{{ this.gallinaDNAList[2][1] }}</td>
                              <td>{{ this.gallinaDNAList[3][1] }}</td>
                              <td>{{ this.gallinaDNAList[4][1] }}</td>
                              <td>{{ this.gallinaDNAList[5][1] }}</td>
                              <td>{{ this.gallinaDNAList[6][1] }}</td>
                              <td>{{ this.gallinaDNAList[7][1] }}</td>
                              <td>{{ this.gallinaDNAList[8][1] }}</td>
                              <td>{{ this.gallinaDNAList[9][1] }}</td>
                              <td>{{ this.gallinaDNAList[10][1] }}</td>
                              <td>{{ this.gallinaDNAList[11][1] }}</td>
                              <td>{{ this.gallinaDNAList[12][1] }}</td>
                              <td>{{ this.gallinaDNAList[13][1] }}</td>
                              <td>{{ this.gallinaDNAList[14][1] }}</td>
                              <td>{{ this.gallinaDNAList[15][1] }}</td>
                              <td>{{ this.gallinaDNAList[16][1] }}</td>
                              <td>{{ this.gallinaDNAList[17][1] }}</td>
                              <td>{{ this.gallinaDNAList[18][1] }}</td>
                              <td>{{ this.gallinaDNAList[19][1] }}</td>
                              <td>{{ this.gallinaDNAList[20][1] }}</td>
                            </tr>
                            <tr>
                              <th>Chest</th>
                              <td>{{ this.gallinaDNAList[0][2] }}</td>
                              <td>{{ this.gallinaDNAList[1][2] }}</td>
                              <td>{{ this.gallinaDNAList[2][2] }}</td>
                              <td>{{ this.gallinaDNAList[3][2] }}</td>
                              <td>{{ this.gallinaDNAList[4][2] }}</td>
                              <td>{{ this.gallinaDNAList[5][2] }}</td>
                              <td>{{ this.gallinaDNAList[6][2] }}</td>
                              <td>{{ this.gallinaDNAList[7][2] }}</td>
                              <td>{{ this.gallinaDNAList[8][2] }}</td>
                              <td>{{ this.gallinaDNAList[9][2] }}</td>
                              <td>{{ this.gallinaDNAList[10][2] }}</td>
                              <td>{{ this.gallinaDNAList[11][2] }}</td>
                              <td>{{ this.gallinaDNAList[12][2] }}</td>
                              <td>{{ this.gallinaDNAList[13][2] }}</td>
                              <td>{{ this.gallinaDNAList[14][2] }}</td>
                              <td>{{ this.gallinaDNAList[15][2] }}</td>
                              <td>{{ this.gallinaDNAList[16][2] }}</td>
                              <td>{{ this.gallinaDNAList[17][2] }}</td>
                              <td>{{ this.gallinaDNAList[18][2] }}</td>
                              <td>{{ this.gallinaDNAList[19][2] }}</td>
                              <td>{{ this.gallinaDNAList[20][2] }}</td>
                            </tr>
                            <tr>
                              <th>Comb</th>
                              <td>{{ this.gallinaDNAList[0][3] }}</td>
                              <td>{{ this.gallinaDNAList[1][3] }}</td>
                              <td>{{ this.gallinaDNAList[2][3] }}</td>
                              <td>{{ this.gallinaDNAList[3][3] }}</td>
                              <td>{{ this.gallinaDNAList[4][3] }}</td>
                              <td>{{ this.gallinaDNAList[5][3] }}</td>
                              <td>{{ this.gallinaDNAList[6][3] }}</td>
                              <td>{{ this.gallinaDNAList[7][3] }}</td>
                              <td>{{ this.gallinaDNAList[8][3] }}</td>
                              <td>{{ this.gallinaDNAList[9][3] }}</td>
                              <td>{{ this.gallinaDNAList[10][3] }}</td>
                              <td>{{ this.gallinaDNAList[11][3] }}</td>
                              <td>{{ this.gallinaDNAList[12][3] }}</td>
                              <td>{{ this.gallinaDNAList[13][3] }}</td>
                              <td>{{ this.gallinaDNAList[14][3] }}</td>
                              <td>{{ this.gallinaDNAList[15][3] }}</td>
                              <td>{{ this.gallinaDNAList[16][3] }}</td>
                              <td>{{ this.gallinaDNAList[17][3] }}</td>
                              <td>{{ this.gallinaDNAList[18][3] }}</td>
                              <td>{{ this.gallinaDNAList[19][3] }}</td>
                              <td>{{ this.gallinaDNAList[20][3] }}</td>
                            </tr>
                            <tr>
                              <th>Eyes</th>
                              <td>{{ this.gallinaDNAList[0][4] }}</td>
                              <td>{{ this.gallinaDNAList[1][4] }}</td>
                              <td>{{ this.gallinaDNAList[2][4] }}</td>
                              <td>{{ this.gallinaDNAList[3][4] }}</td>
                              <td>{{ this.gallinaDNAList[4][4] }}</td>
                              <td>{{ this.gallinaDNAList[5][4] }}</td>
                              <td>{{ this.gallinaDNAList[6][4] }}</td>
                              <td>{{ this.gallinaDNAList[7][4] }}</td>
                              <td>{{ this.gallinaDNAList[8][4] }}</td>
                              <td>{{ this.gallinaDNAList[9][4] }}</td>
                              <td>{{ this.gallinaDNAList[10][4] }}</td>
                              <td>{{ this.gallinaDNAList[11][4] }}</td>
                              <td>{{ this.gallinaDNAList[12][4] }}</td>
                              <td>{{ this.gallinaDNAList[13][4] }}</td>
                              <td>{{ this.gallinaDNAList[14][4] }}</td>
                              <td>{{ this.gallinaDNAList[15][4] }}</td>
                              <td>{{ this.gallinaDNAList[16][4] }}</td>
                              <td>{{ this.gallinaDNAList[17][4] }}</td>
                              <td>{{ this.gallinaDNAList[18][4] }}</td>
                              <td>{{ this.gallinaDNAList[19][4] }}</td>
                              <td>{{ this.gallinaDNAList[20][4] }}</td>
                            </tr>
                            <tr>
                              <th>Feet</th>
                              <td>{{ this.gallinaDNAList[0][5] }}</td>
                              <td>{{ this.gallinaDNAList[1][5] }}</td>
                              <td>{{ this.gallinaDNAList[2][5] }}</td>
                              <td>{{ this.gallinaDNAList[3][5] }}</td>
                              <td>{{ this.gallinaDNAList[4][5] }}</td>
                              <td>{{ this.gallinaDNAList[5][5] }}</td>
                              <td>{{ this.gallinaDNAList[6][5] }}</td>
                              <td>{{ this.gallinaDNAList[7][5] }}</td>
                              <td>{{ this.gallinaDNAList[8][5] }}</td>
                              <td>{{ this.gallinaDNAList[9][5] }}</td>
                              <td>{{ this.gallinaDNAList[10][5] }}</td>
                              <td>{{ this.gallinaDNAList[11][5] }}</td>
                              <td>{{ this.gallinaDNAList[12][5] }}</td>
                              <td>{{ this.gallinaDNAList[13][5] }}</td>
                              <td>{{ this.gallinaDNAList[14][5] }}</td>
                              <td>{{ this.gallinaDNAList[15][5] }}</td>
                              <td>{{ this.gallinaDNAList[16][5] }}</td>
                              <td>{{ this.gallinaDNAList[17][5] }}</td>
                              <td>{{ this.gallinaDNAList[18][5] }}</td>
                              <td>{{ this.gallinaDNAList[19][5] }}</td>
                              <td>{{ this.gallinaDNAList[20][5] }}</td>
                            </tr>
                            <tr>
                              <th>Head</th>
                              <td>{{ this.gallinaDNAList[0][6] }}</td>
                              <td>{{ this.gallinaDNAList[1][6] }}</td>
                              <td>{{ this.gallinaDNAList[2][6] }}</td>
                              <td>{{ this.gallinaDNAList[3][6] }}</td>
                              <td>{{ this.gallinaDNAList[4][6] }}</td>
                              <td>{{ this.gallinaDNAList[5][6] }}</td>
                              <td>{{ this.gallinaDNAList[6][6] }}</td>
                              <td>{{ this.gallinaDNAList[7][6] }}</td>
                              <td>{{ this.gallinaDNAList[8][6] }}</td>
                              <td>{{ this.gallinaDNAList[9][6] }}</td>
                              <td>{{ this.gallinaDNAList[10][6] }}</td>
                              <td>{{ this.gallinaDNAList[11][6] }}</td>
                              <td>{{ this.gallinaDNAList[12][6] }}</td>
                              <td>{{ this.gallinaDNAList[13][6] }}</td>
                              <td>{{ this.gallinaDNAList[14][6] }}</td>
                              <td>{{ this.gallinaDNAList[15][6] }}</td>
                              <td>{{ this.gallinaDNAList[16][6] }}</td>
                              <td>{{ this.gallinaDNAList[17][6] }}</td>
                              <td>{{ this.gallinaDNAList[18][6] }}</td>
                              <td>{{ this.gallinaDNAList[19][6] }}</td>
                              <td>{{ this.gallinaDNAList[20][6] }}</td>
                            </tr>
                            <tr>
                              <th>Legs</th>
                              <td>{{ this.gallinaDNAList[0][7] }}</td>
                              <td>{{ this.gallinaDNAList[1][7] }}</td>
                              <td>{{ this.gallinaDNAList[2][7] }}</td>
                              <td>{{ this.gallinaDNAList[3][7] }}</td>
                              <td>{{ this.gallinaDNAList[4][7] }}</td>
                              <td>{{ this.gallinaDNAList[5][7] }}</td>
                              <td>{{ this.gallinaDNAList[6][7] }}</td>
                              <td>{{ this.gallinaDNAList[7][7] }}</td>
                              <td>{{ this.gallinaDNAList[8][7] }}</td>
                              <td>{{ this.gallinaDNAList[9][7] }}</td>
                              <td>{{ this.gallinaDNAList[10][7] }}</td>
                              <td>{{ this.gallinaDNAList[11][7] }}</td>
                              <td>{{ this.gallinaDNAList[12][7] }}</td>
                              <td>{{ this.gallinaDNAList[13][7] }}</td>
                              <td>{{ this.gallinaDNAList[14][7] }}</td>
                              <td>{{ this.gallinaDNAList[15][7] }}</td>
                              <td>{{ this.gallinaDNAList[16][7] }}</td>
                              <td>{{ this.gallinaDNAList[17][7] }}</td>
                              <td>{{ this.gallinaDNAList[18][7] }}</td>
                              <td>{{ this.gallinaDNAList[19][7] }}</td>
                              <td>{{ this.gallinaDNAList[20][7] }}</td>
                            </tr>
                            <tr>
                              <th>Wattle</th>
                              <td>{{ this.gallinaDNAList[0][8] }}</td>
                              <td>{{ this.gallinaDNAList[1][8] }}</td>
                              <td>{{ this.gallinaDNAList[2][8] }}</td>
                              <td>{{ this.gallinaDNAList[3][8] }}</td>
                              <td>{{ this.gallinaDNAList[4][8] }}</td>
                              <td>{{ this.gallinaDNAList[5][8] }}</td>
                              <td>{{ this.gallinaDNAList[6][8] }}</td>
                              <td>{{ this.gallinaDNAList[7][8] }}</td>
                              <td>{{ this.gallinaDNAList[8][8] }}</td>
                              <td>{{ this.gallinaDNAList[9][8] }}</td>
                              <td>{{ this.gallinaDNAList[10][8] }}</td>
                              <td>{{ this.gallinaDNAList[11][8] }}</td>
                              <td>{{ this.gallinaDNAList[12][8] }}</td>
                              <td>{{ this.gallinaDNAList[13][8] }}</td>
                              <td>{{ this.gallinaDNAList[14][8] }}</td>
                              <td>{{ this.gallinaDNAList[15][8] }}</td>
                              <td>{{ this.gallinaDNAList[16][8] }}</td>
                              <td>{{ this.gallinaDNAList[17][8] }}</td>
                              <td>{{ this.gallinaDNAList[18][8] }}</td>
                              <td>{{ this.gallinaDNAList[19][8] }}</td>
                              <td>{{ this.gallinaDNAList[20][8] }}</td>
                            </tr>
                            <tr>
                              <th>Wings</th>
                              <td>{{ this.gallinaDNAList[0][9] }}</td>
                              <td>{{ this.gallinaDNAList[1][9] }}</td>
                              <td>{{ this.gallinaDNAList[2][9] }}</td>
                              <td>{{ this.gallinaDNAList[3][9] }}</td>
                              <td>{{ this.gallinaDNAList[4][9] }}</td>
                              <td>{{ this.gallinaDNAList[5][9] }}</td>
                              <td>{{ this.gallinaDNAList[6][9] }}</td>
                              <td>{{ this.gallinaDNAList[7][9] }}</td>
                              <td>{{ this.gallinaDNAList[8][9] }}</td>
                              <td>{{ this.gallinaDNAList[9][9] }}</td>
                              <td>{{ this.gallinaDNAList[10][9] }}</td>
                              <td>{{ this.gallinaDNAList[11][9] }}</td>
                              <td>{{ this.gallinaDNAList[12][9] }}</td>
                              <td>{{ this.gallinaDNAList[13][9] }}</td>
                              <td>{{ this.gallinaDNAList[14][9] }}</td>
                              <td>{{ this.gallinaDNAList[15][9] }}</td>
                              <td>{{ this.gallinaDNAList[16][9] }}</td>
                              <td>{{ this.gallinaDNAList[17][9] }}</td>
                              <td>{{ this.gallinaDNAList[18][9] }}</td>
                              <td>{{ this.gallinaDNAList[19][9] }}</td>
                              <td>{{ this.gallinaDNAList[20][9] }}</td>
                            </tr>
                            </tbody>
                          </table>

                          <div class="row justify-content-center align-items-center">
                            <div class="col indexfontlower">[Ex: The Number of Gallinas with a Beak Trait of Gene 0 is: {{ this.gallinaDNAList[0][0] }}]</div>
                          </div>
                          <br/>
                          <br/>
                          <div class="row justify-content-center align-items-center">
                            <div class="col indexfontlower">Gallina Traits and their corresponding DNA position</div>
                          </div>
                          <table class="comicGreen">
                            <thead>
                            <tr>
                              <th>Beak</th>
                              <th>Belly</th>
                              <th>Chest</th>
                              <th>Comb</th>
                              <th>Eyes</th>
                              <th>Feet</th>
                              <th>Head</th>
                              <th>Legs</th>
                              <th>Wattle</th>
                              <th>Wings</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td>1</td>
                              <td>2</td>
                              <td>3</td>
                              <td>4</td>
                              <td>5</td>
                              <td>6</td>
                              <td>7</td>
                              <td>8</td>
                              <td>9</td>
                              <td>10</td>
                            </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>




                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="$screen.width >= 992" class="modal-box mt-4">
            <div class="mdialog" role="document">
              <div class="modal-content clearfix">
                <div class="modal-body">
                  <div class="row align-items-center justify-content-evenly">
                    <div class="col-10 align-items-center justify-content-evenly dark-text-section p-5 pt-4" style="padding: 0 0 1rem 0 !important;">
                      <img src="../../public/icons/howtoplay.svg" alt="How to play"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div v-if="$screen.width >= 992" class="row mt-4 frontfooter justify-content-lg-evenly">
            <div class="col-12">
              <div class="modal-box">
                <div class="mdialog" role="document">
                  <div class="modal-content clearfix">
                    <div class="modal-body" style="padding:20px;">
                      <h3 class="title" style="position:relative; right:0px; font-size: 20px;"><img class="flip-horizontally mx-3"
                                                                                                    src="../../public/icons/chick-mygallinas-icon.svg" alt="Gallinas" width="40px"><span class="discordcolor">Come chat with fellow Gallina Breeders on</span> <a href="https://discord.gg/RXYxy2mRM5" target="_blank"><button type="button" class="mx-3 btnsearch" style="position:relative; top: -2px; outline:none;">
                        <svg width="124" height="34" viewBox="0 0 124 34" class="logo-TA52YN bgdiscord"><g fill="currentColor"><path d="M26.0015 6.9529C24.0021 6.03845 21.8787 5.37198 19.6623 5C19.3833 5.48048 19.0733 6.13144 18.8563 6.64292C16.4989 6.30193 14.1585 6.30193 11.8336 6.64292C11.6166 6.13144 11.2911 5.48048 11.0276 5C8.79575 5.37198 6.67235 6.03845 4.6869 6.9529C0.672601 12.8736 -0.41235 18.6548 0.130124 24.3585C2.79599 26.2959 5.36889 27.4739 7.89682 28.2489C8.51679 27.4119 9.07477 26.5129 9.55525 25.5675C8.64079 25.2265 7.77283 24.808 6.93587 24.312C7.15286 24.1571 7.36986 23.9866 7.57135 23.8161C12.6241 26.1255 18.0969 26.1255 23.0876 23.8161C23.3046 23.9866 23.5061 24.1571 23.7231 24.312C22.8861 24.808 22.0182 25.2265 21.1037 25.5675C21.5842 26.5129 22.1422 27.4119 22.7621 28.2489C25.2885 27.4739 27.8769 26.2959 30.5288 24.3585C31.1952 17.7559 29.4733 12.0212 26.0015 6.9529ZM10.2527 20.8402C8.73376 20.8402 7.49382 19.4608 7.49382 17.7714C7.49382 16.082 8.70276 14.7025 10.2527 14.7025C11.7871 14.7025 13.0425 16.082 13.0115 17.7714C13.0115 19.4608 11.7871 20.8402 10.2527 20.8402ZM20.4373 20.8402C18.9183 20.8402 17.6768 19.4608 17.6768 17.7714C17.6768 16.082 18.8873 14.7025 20.4373 14.7025C21.9717 14.7025 23.2271 16.082 23.1961 17.7714C23.1961 19.4608 21.9872 20.8402 20.4373 20.8402Z"></path><path d="M41.2697 9.86615H47.8585C49.4394 9.86615 50.7878 10.1141 51.8883 10.6101C52.9887 11.1061 53.8102 11.7881 54.3527 12.6715C54.8951 13.555 55.1741 14.5624 55.1741 15.7094C55.1741 16.8253 54.8952 17.8328 54.3217 18.7472C53.7482 19.6462 52.8803 20.3746 51.7178 20.9016C50.5554 21.4286 49.1139 21.6921 47.3935 21.6921H41.2697V9.86615ZM47.316 18.6852C48.3854 18.6852 49.2069 18.4217 49.7804 17.8793C50.3539 17.3523 50.6484 16.6083 50.6484 15.6939C50.6484 14.8414 50.3849 14.1594 49.8734 13.648C49.3619 13.1365 48.587 12.873 47.5485 12.873H45.4871V18.6852H47.316Z"></path><path d="M65.4362 21.6774C64.5217 21.4449 63.7003 21.1039 62.9718 20.6389V17.8335C63.5298 18.2675 64.2582 18.6085 65.1882 18.8875C66.1181 19.1665 67.0171 19.306 67.8851 19.306C68.288 19.306 68.598 19.2595 68.7995 19.151C69.001 19.0425 69.1095 18.9185 69.1095 18.7635C69.1095 18.593 69.0475 18.4535 68.939 18.345C68.8305 18.2365 68.6135 18.1435 68.288 18.0505L66.2576 17.6011C65.0952 17.3376 64.2737 16.9501 63.7777 16.4851C63.2818 16.0201 63.0493 15.3847 63.0493 14.6097C63.0493 13.9587 63.2663 13.3853 63.6847 12.9048C64.1187 12.4243 64.7232 12.0523 65.5137 11.7888C66.3041 11.5254 67.2186 11.3859 68.288 11.3859C69.2335 11.3859 70.1014 11.4789 70.8919 11.6959C71.6823 11.8973 72.3333 12.1608 72.8448 12.4708V15.1212C72.3178 14.8112 71.6979 14.5632 71.0159 14.3772C70.3184 14.1912 69.6055 14.0982 68.877 14.0982C67.823 14.0982 67.2961 14.2842 67.2961 14.6407C67.2961 14.8112 67.3736 14.9352 67.5441 15.0282C67.7146 15.1212 68.009 15.1987 68.443 15.2917L70.1324 15.6017C71.2329 15.7876 72.0543 16.1286 72.5968 16.6091C73.1393 17.0896 73.4028 17.787 73.4028 18.7325C73.4028 19.7555 72.9533 20.5769 72.0543 21.1659C71.1554 21.7704 69.8844 22.0648 68.2415 22.0648C67.2806 22.0338 66.3506 21.9098 65.4362 21.6774Z"></path><path d="M77.5891 21.3213C76.6281 20.8408 75.8842 20.2054 75.4037 19.3994C74.9077 18.5934 74.6752 17.679 74.6752 16.656C74.6752 15.6486 74.9232 14.7341 75.4347 13.9437C75.9462 13.1377 76.6901 12.5177 77.6666 12.0528C78.643 11.6033 79.821 11.3708 81.1849 11.3708C82.8743 11.3708 84.2693 11.7273 85.3852 12.4402V15.5246C84.9977 15.2611 84.5328 15.0286 84.0058 14.8736C83.4788 14.7031 82.9208 14.6256 82.3319 14.6256C81.2779 14.6256 80.472 14.8116 79.8675 15.1991C79.2785 15.5866 78.984 16.0826 78.984 16.7025C78.984 17.307 79.263 17.803 79.852 18.1905C80.4254 18.5779 81.2624 18.7794 82.3474 18.7794C82.9053 18.7794 83.4633 18.7019 84.0058 18.5314C84.5483 18.3609 85.0287 18.175 85.4162 17.927V20.9183C84.1762 21.6623 82.7348 22.0343 81.1074 22.0343C79.728 22.0343 78.5655 21.7863 77.5891 21.3213Z"></path><path d="M89.8041 21.3213C88.8276 20.8408 88.0837 20.2054 87.5722 19.3839C87.0607 18.5624 86.7972 17.648 86.7972 16.625C86.7972 15.6176 87.0607 14.7031 87.5722 13.9127C88.0837 13.1222 88.8276 12.5022 89.7886 12.0528C90.7495 11.6033 91.9119 11.3708 93.2464 11.3708C94.5794 11.3708 95.7418 11.5878 96.7028 12.0528C97.6637 12.5022 98.4077 13.1222 98.9192 13.9127C99.4306 14.7031 99.6786 15.6021 99.6786 16.625C99.6786 17.6325 99.4306 18.5624 98.9192 19.3839C98.4077 20.2054 97.6792 20.8563 96.7028 21.3213C95.7263 21.7863 94.5794 22.0343 93.2464 22.0343C91.9274 22.0343 90.7805 21.7863 89.8041 21.3213ZM94.9358 18.3299C95.3388 17.927 95.5558 17.369 95.5558 16.7025C95.5558 16.0206 95.3543 15.4936 94.9358 15.0906C94.5174 14.6876 93.9594 14.4861 93.2619 14.4861C92.5335 14.4861 91.9739 14.6876 91.5555 15.0906C91.1525 15.4936 90.9355 16.0206 90.9355 16.7025C90.9355 17.3845 91.137 17.927 91.5555 18.3299C91.9739 18.7484 92.5335 18.9499 93.2619 18.9499C93.9594 18.9344 94.5329 18.7329 94.9358 18.3299Z"></path><path d="M110.048 11.9901V15.6325C109.614 15.3535 109.056 15.214 108.374 15.214C107.475 15.214 106.777 15.493 106.297 16.0354C105.816 16.5779 105.568 17.4304 105.568 18.5773V21.6772H101.43V11.8196H105.491V14.966C105.708 13.819 106.08 12.9666 106.576 12.4241C107.072 11.8816 107.723 11.5872 108.513 11.5872C109.102 11.5872 109.614 11.7267 110.048 11.9901Z"></path><path d="M124 9.52563V21.6925H119.862V19.4761C119.505 20.3131 118.978 20.9486 118.265 21.3825C117.551 21.8165 116.667 22.0335 115.613 22.0335C114.683 22.0335 113.862 21.801 113.164 21.3515C112.467 20.9021 111.925 20.2666 111.553 19.4761C111.181 18.6702 110.995 17.7712 110.995 16.7793C110.979 15.7408 111.181 14.8109 111.599 13.9894C112.002 13.168 112.591 12.5325 113.335 12.0675C114.079 11.6025 114.931 11.37 115.892 11.37C117.861 11.37 119.18 12.2225 119.862 13.9429V9.52563H124ZM119.242 18.2517C119.66 17.8487 119.877 17.3062 119.877 16.6553C119.877 16.0198 119.676 15.5083 119.257 15.1209C118.839 14.7334 118.281 14.5319 117.582 14.5319C116.884 14.5319 116.326 14.7334 115.908 15.1364C115.489 15.5393 115.288 16.0508 115.288 16.7018C115.288 17.3527 115.489 17.8642 115.908 18.2672C116.326 18.6702 116.869 18.8717 117.566 18.8717C118.265 18.8717 118.823 18.6702 119.242 18.2517Z"></path><path d="M58.9885 12.4091C60.1772 12.4091 61.1429 11.5416 61.1429 10.4717C61.1429 9.40164 60.1772 8.5343 58.9885 8.5343C57.7981 8.5343 56.8341 9.40164 56.8341 10.4717C56.8341 11.5416 57.7981 12.4091 58.9885 12.4091Z"></path><path d="M61.1429 13.741C59.8254 14.3144 58.1825 14.3299 56.8341 13.741V21.6921H61.1429V13.741Z"></path></g></svg>
                      </button></a><img
                          src="../../public/icons/chick-mygallinas-icon.svg" alt="Gallinas" width="40px"></h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="$screen.width > 1200" class="row mt-4 frontfooter justify-content-lg-evenly">
            <div class="col-2">
              <div class="modal-box">
                <div class="mdialog" role="document">
                  <div class="modal-content clearfix">
                    <div class="modal-body" style="padding:20px;">
                      <a href="mailto:help@gallinas.io" target="_blank">
                        <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                          <img src="../../public/icons/email.svg" alt="help@gallinas.io" width="40px"
                               style="position:relative; top:8px;">
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="modal-box">
                <div class="mdialog" role="document">
                  <div class="modal-content clearfix">
                    <div class="modal-body" style="padding:20px;">
                      <a href="https://twitter.com/KadenaGallinas" target="_blank">
                        <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                          <img src="../../public/icons/twitter.svg" alt="@KadenaGallinas" width="40px"
                               style="position:relative; top:8px;">
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="modal-box">
                <div class="mdialog" role="document">
                  <div class="modal-content clearfix">
                    <div class="modal-body" style="padding:20px;">
                      <a href="https://t.me/gallinasunofficial" target="_blank">
                        <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                          <img src="../../public/icons/telegram.svg" alt="Gallinas.io" width="40px"
                               style="position:relative; top:8px;">
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div v-if="$screen.width <= 1200" class="row mt-4 frontfooter justify-content-evenly">
            <div class="col-3">
              <div class="modal-body" style="padding:20px;">
                <a href="mailto:help@gallinas.io" target="_blank">
                  <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                    <img src="../../public/icons/email.svg" alt="help@gallinas.io" width="40px"
                         style="position:relative; top:8px;">
                  </div>
                </a>
              </div>
            </div>
            <div class="col-3">
              <div class="modal-body" style="padding:20px;">
                <a href="https://twitter.com/KadenaGallinas" target="_blank">
                  <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                    <img src="../../public/icons/twitter.svg" alt="@KadenaGallinas" width="40px"
                         style="position:relative; top:8px;">
                  </div>
                </a>
              </div>
            </div>
            <div class="col-3">
              <div class="modal-body" style="padding:20px;">
                <a href="https://t.me/+7eMOp07DTuM2YTg8" target="_blank">
                  <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                    <img src="../../public/icons/telegram.svg" alt="Gallinas.io" width="40px"
                         style="position:relative; top:8px;">
                  </div>
                </a>
              </div>
            </div>

          </div>

          <div class="mt-4">
            <br/>
          </div>

          <div>

          </div>


        </div>
      </Scroll-Div>
    </section>
    <section v-if="this.showLoadingModal === false && $screen.width <= 576">

      <div class="modal-box">
        <div class="mdialog" role="document">
          <div class="modal-content-no-shadow clearfix">
            <div class="modal-body">
              <div class="row align-items-center justify-content-center">
                <div class="col-12 align-items-center">
                  <img @click="showDesktopOnlyModal = !showDesktopOnlyModal"
                       src="../../public/icons/electronic-farm.svg" width="80%"
                       alt="Breed Gallinas"/>
                </div>
              </div>
              <div class="row align-items-center justify-content-center mt-4 m-3">
                <div class="col-11 align-items-center dark-text-section">
                      <h3 @click="showDesktopOnlyModal = !showDesktopOnlyModal" class="title-mobile">Start your own
                        Gallina
                        farm on Kadena!</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-content-no-shadow mt-4 m-3">
        <div class="row frontfooter-mobile justify-content-evenly">
          <div class="col-3">
            <div class="modal-body" style="padding:0;">
              <a href="mailto:help@gallinas.io" target="_blank">
                <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                  <img src="../../public/icons/email.svg" alt="help@gallinas.io" width="40px"
                       style="position:relative; top:8px;">
                </div>
              </a>
            </div>
          </div>
          <div class="col-3">
            <div class="modal-body" style="padding:0;">
              <a href="https://twitter.com/KadenaGallinas" target="_blank">
                <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                  <img src="../../public/icons/twitter.svg" alt="@KadenaGallinas" width="40px"
                       style="position:relative; top:8px;">
                </div>
              </a>
            </div>
          </div>
          <div class="col-3">
            <div class="modal-body" style="padding:0;">
              <a href="https://t.me/kadenagallinas" target="_blank">
                <div class="col-equip-lg equipped-item-lg my-flex my-shadow">
                  <img src="../../public/icons/telegram.svg" alt="Gallinas.io" width="40px"
                       style="position:relative; top:8px;">
                </div>
              </a>
            </div>
          </div>

        </div>
      </div>


    </section>

    <VModalMobileOnly v-if="showDesktopOnlyModal" :show-gold-header="false" content-class="darkMode"
                      :prevent-click="true" class-name="connect-wallet-modal" confirm-name="Confirm" cancel-name="Close"
                      v-model="showDesktopOnlyModal" @confirm="showDesktopOnlyModal = !showDesktopOnlyModal"
                      @cancel="showDesktopOnlyModal = !showDesktopOnlyModal" name="intro"
                      modaltitle="Connect My Account">

      <div class="modal-box">
        <div class="mdialog" role="document">
          <div class="modal-content-no-shadow clearfix">
            <div class="modal-body">
              <div class="row align-items-center justify-content-evenly">
                <div class="col-md-4 d-flex align-items-center justify-content-evenly">
                  <img src="../../public/icons/no-mobile-farmer-on-computer.svg" width="300px"
                       alt="Gallinas.io Plays Best On Desktop"/>
                </div>
                <div class="col-md-4 d-flex align-items-center justify-content-evenly mt-2">

                  <h3 class="title">Gallinas.io plays best on your computer.</h3>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </VModalMobileOnly>



  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import ScrollDiv from "vue-scroll-div";
import FlipCard from "@/components/FlipCard";
import VModalMobileOnly from "@/components/VModalMobileOnly";



export default {
  name: "HomePage",
  components: {
    ScrollDiv,
    FlipCard,
    VModalMobileOnly,

  },
  data() {
    return {
      debug: false,
      showLoadingModal: true,
      showDesktopOnlyModal: false,
      gallinasearchvalue: 0,
      gallinaDNAList: [],
      searching: false,
      searched: false,
      gallinaSetSearchList: [
        {id: 0, name: "Set 0", value: "0"},
        {id: 1, name: "Set 1) Fly Swatter", value: "1"},
        {id: 3, name: "Set 3) Thanos V.I.P.", value: "3"},
        {id: 5, name: "Set 5) Kitty Kad", value: "5"}
      ],
      list: 6,
    };
  },
  methods: {
    ...mapActions("accounts", ["getAllGameGallinas", "getAllGameEggs", "bindDNARecords"]),
    ...mapGetters("accounts", ["getAccountExists", "getGameTotalGallinas", "getGameTotalEggs", "getAccountConfirmed"]),

    searchtovalue(row) {

      if (this.debug) {
        console.log(JSON.stringify(row));
        console.log(row);
        console.log(row.id);
        console.log(row.value);
      }

      this.gallinasearchvalue = row.id;
    },

    async clickSearch1(){
      this.searching = true;

      await this.clickSearch();

    },

    async clickSearch() {
      this.searching = true;
      //getGallinasForSaleByGene

      //For each gene we want to check
      //where gene_1_p = 0 - 20
      let genelist = ["gene_1_p","gene_2_p","gene_3_p","gene_4_p","gene_5_p","gene_6_p","gene_7_p","gene_8_p","gene_9_p","gene_10_p"];

      let t_matrix = [];
      let t_cols = 21;

      for(let k = 0; k < t_cols; k++){
        t_matrix[k]=[];
      }

      for(let i = 0; i<21; i++){//for each gene position we will make a loop and check the gene list

        if(this.debug){
          console.log("LOOP " + i);
        }

        for(let j = 0; j<10; j++){ //for each gene list we will make a query to check for its dna

          if(this.debug){
            console.log("CHECKING IF "+genelist[j]+" is equal to "+i);
          }


          let payload = {
            gene: genelist[j],
            geneval: i,
            special: this.gallinasearchvalue,
          };
          if(this.debug === true) {
            console.log("I: " + i);
            console.log("J: " + j);
            console.log("DNA SEARCH PAYLOAD");
            console.log(payload);
          }

          t_matrix[i][j] = await this.bindDNARecords(payload);

          if(this.debug){
            console.log("t_matrix[i][j]");
            console.log(t_matrix[i][j]);
          }


        }
      }

      this.gallinaDNAList = t_matrix;
      this.searching = false;
      this.searched = true;

      if(this.debug){
        console.log("TMATRIX");
        console.log(t_matrix);
      }

    },


  },
  async created() {

    //Get homepage stats
    await this.$store.dispatch("accounts/getAllGameGallinas");
    await this.$store.dispatch("accounts/getAllGameEggs");

    //Now we need to get set 0s dna records
    //await this.clickSearch();

    //Close loading screen
    setTimeout(async () => {
      this.showLoadingModal = false;
    }, 10);
  },
};
</script>
<style scoped>

.discordcolor{
  color: #ffffff !important;
}

.btnsearch {
  color: #fff;
  background-color: #5631c7;
  font-family: 'Comfortaa', cursive;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 10px 12px 6px;
  border: none;
  border-radius: 0;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease 0s;
}

.btnsearch:active {
  margin-left: 10px;
  margin-top: 10px;
  background-color: #310d9e;
}

.btnsearch:focus,
.btnsearch:hover {
  font-family: 'Mochiy Pop P One', sans-serif;
}

.btnsearch:hover:before,
.btnsearch:hover:after {
  content: '';
  z-index: -1;
}

.btnsearch:before,
.btnsearch:after {
  content: '';
  background-color: #230972;
  height: 7px;
  width: 100%;
  transform: skewX(45deg);
  position: absolute;
  right: -3.5px;
  bottom: -7px;
  z-index: -1;
  transition: all 0.3s ease 0s;
}

.btnsearch:after {
  background-color: #22096c;
  height: 100%;
  width: 7px;
  transform: skewY(45deg);
  right: -7px;
  bottom: -3.5px;
}

.btnsearch:active:before {
  height: 3px;
  right: -1.5px;
  bottom: -3px;
}

.btnsearch:active:after {
  width: 3px;
  bottom: -1.5px;
  right: -3px;
}

.bgdiscord{
  background-color: #5631c7;
}

.dark-text-section {
  border: 5px #ffda86;
  border-radius: 22px;
  border-style: inset;
  background-color: #86bfb0d4;
  margin-left: 2rem;
  margin-right: 2rem;
}

.small-font-3d {
  font-family: 'Comic Neue', cursive;
  color: #ffffff;
  text-shadow: 0 1px 0 #ccc, 0 2px 0 #ccc, 0 3px 0 transparent, 0 4px 0 transparent,
  0 5px 0 transparent, 0 6px 0 transparent, 0 7px 0 transparent, 0 8px 0 transparent,
  0 9px 0 transparent, 0 5px 5px rgba(0, 0, 0, 0.2);
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 10px 0;
}

.col-equip-lg {
  width: 60px;
  height: 60px;
}

.equipped-item-lg {
  box-shadow: 0px 5px 1px 0px rgba(0, 0, 0, 0.75);
  border: 3px outset #ffda86;
  border-radius: 20px;
  margin: .5rem auto;
  background: linear-gradient(#fbb03b, transparent),
  linear-gradient(to top left, #fbb03b, transparent),
  linear-gradient(to top right, #fdc400, transparent);
  background-blend-mode: screen;
  /*-webkit-background-clip: text;*/
  height: 60px;
  padding: 0px;
}

.paper {
  position: relative;
  height: 450px;
  width: 350px;
  background: rgba(255, 255, 255, 0.9);
  margin: -275px -225px;
  box-shadow: 0px 0px 5px 0px #888;
}

.paper::before {
  content: '';
  position: absolute;
  left: 45px;
  height: 100%;
  width: 2px;
  background: rgba(255, 0, 0, 0.4);
}

.lines {
  margin-top: 40px;
  height: calc(100% - 40px);
  width: 100%;
  background-image: repeating-linear-gradient(white 0px, white 24px, steelblue 25px);
}

.text {
  position: absolute;
  top: 65px;
  left: 55px;
  bottom: 10px;
  right: 10px;
  line-height: 25px;
  font-family: 'Indie Flower';
  overflow: hidden;
  outline: none;
}

.holes {
  position: absolute;
  left: 10px;
  height: 25px;
  width: 25px;
  background: #e8c898;
  border-radius: 50%;
  box-shadow: inset 0px 0px 2px 0px #888;
}

.hole-top {
  top: 10%;
}

.hole-middle {
  top: 50%;
}

.hole-bottom {
  bottom: 10%;
}

.frontfooter {
  display: flex;
  position: relative;
  justify-content: center;
}

.frontfooter-mobile {
  display: flex;
  position: relative;
  justify-content: center;
}


.modal-box .mdialog {
  width: 80%;
  margin: 70px auto 0;
  margin-top: 0px;

}

@media (max-width: 576px) {
  .modal-box .mdialog {
    width: 95%;
  }
}

.modal.fade .mdialog {
  opacity: 0;
  transform: translate(30%, 30%) scale(0.5);
}

.modal.fade.in .mdialog {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

.modal-box .mdialog .modal-content {
  border: 5px outset #ffda86;
  border-radius: 35px;
  /*box-shadow: 0px 0px 20px #c2803a, 0px 0px 20px #f6a960;*/
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
  background-color: #e8c898;
}

.modal-content-no-shadow {
  border: 5px outset #ffda86;
  border-radius: 35px;
  background-color: #e8c898;
}

.modal-box .mdialog .modal-content .modal-body {
  padding: 65px 45px;
}

.modal-box .mdialog .modal-content .modal-body .icon {
  color: #827f3b;
  font-size: 80px;
  line-height: 145px;
  width: 100px;
  height: 100px;
  padding-left: 0px;
  padding-right: 10px;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  left: 25px;
}

.modal-box .mdialog .modal-content .modal-body .inner-content {
  padding: 0 0 0 170px;
  margin: 0 0 30px;
  margin-top: 0px;
}

.modal-box .mdialog .modal-content .modal-body .title {
  font-family: 'Mochiy Pop P One', sans-serif;
  color: #ffffff;
  text-shadow: 0 1px 0 #ccc, 0 2px 0 #ccc, 0 3px 0 #ccc, 0 4px 0 #ccc,
  0 5px 0 #ccc, 0 6px 0 transparent, 0 7px 0 transparent, 0 8px 0 transparent,
  0 9px 0 transparent, 0 5px 5px rgba(0, 0, 0, 0.4);
  font-size: 30px;
  font-weight: 600;
  margin: 0 0 10px 0;
}

.title-mobile {
  font-family: 'Mochiy Pop P One', sans-serif;
  color: #ffffff;
  text-shadow: 0 1px 0 #ccc, 0 2px 0 #ccc, 0 3px 0 #ccc, 0 4px 0 transparent,
  0 5px 0 transparent, 0 6px 0 transparent, 0 7px 0 transparent, 0 8px 0 transparent,
  0 9px 0 transparent, 0 5px 5px rgba(0, 0, 0, 0.4);
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 10px 0;
  line-height: 30px;
}

.modal-box .mdialog .modal-content .modal-body .description {
  color: #ffffff;
  font-size: 18px;
  margin: 0;
  padding-top: 20px;
  font-family: 'Comic Neue', cursive;
}

.modal-box .mdialog .modal-content .modal-body .form-control {
  color: #6d5a36;
  background: #eee8dd;
  font-size: 15px;
  letter-spacing: 1px;
  height: 45px;
  padding: 2px 15px;
  border-radius: 50px 0 0 50px;
  border: 1px solid #ddd8cf;
  box-shadow: none;
}

.modal-box .mdialog .modal-content .modal-body .form-control:focus {
  border: 1px solid #ddd8cf;
  box-shadow: none;
}

.modal-box .mdialog .modal-content .modal-body .form-control::placeholder {
  color: rgba(0, 0, 0, 0.5);
  font-size: 13px;
}

.modal-box .mdialog .modal-content .modal-body .subscribe {
  color: #fff;
  background: #ebbf53;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 13px 20px 11px;
  border: none;
  border-radius: 0 50px 50px 0;
  display: block;
  transition: all 0.3s;
}

.modal-box .mdialog .modal-content .modal-body .subscribe:hover,
.modal-box .mdialog .modal-content .modal-body .subscribe:focus {
  background: #827f3b;
}


table.comicGreen {
  font-family: "Comic Sans MS", cursive, sans-serif;
  border: 2px solid #4F7849;
  background-color: #EEEEEE;
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}
table.comicGreen td, table.comicGreen th {
  border: 2px solid #4F7849;
  padding: 3px 2px;
}
table.comicGreen tbody td {
  font-size: 10px;
  font-weight: bold;
  color: #4F7849;
  width: 20px;
}
table.comicGreen tr:nth-child(even) {
  background: #CEE0CC;
}
table.comicGreen thead {
  background: #4F7849;
  background: -moz-linear-gradient(top, #7b9a76 0%, #60855b 66%, #4F7849 100%);
  background: -webkit-linear-gradient(top, #7b9a76 0%, #60855b 66%, #4F7849 100%);
  background: linear-gradient(to bottom, #7b9a76 0%, #60855b 66%, #4F7849 100%);
  border-bottom: 1px solid #444444;
}
table.comicGreen thead th {
  font-size: 10px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  border-left: 2px solid #D0E4F5;
  width: 20px;
}
table.comicGreen thead th:first-child {
  border-left: none;
}

table.comicGreen th {
  background: #4F7849;
  background: -moz-linear-gradient(top, #7b9a76 0%, #60855b 66%, #4F7849 100%);
  background: -webkit-linear-gradient(top, #7b9a76 0%, #60855b 66%, #4F7849 100%);
  background: linear-gradient(to bottom, #7b9a76 0%, #60855b 66%, #4F7849 100%);
  border-bottom: 1px solid #444444;
  font-size: 10px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  border-right: 2px solid #D0E4F5;
  font-family: 'Mochiy Pop P One', sans-serif
}

table.comicGreen tfoot td {
  font-size: 21px;
}

.gallinacansearch {
  width: 200px;
}

.loadereye {
  width: 100px;
  height: 25px;
  position: relative;
  margin: 0px auto 0;
}

.loadereye span {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
}

.loadereye span:nth-child(1) {
  background: #005395;
}

.loadereye span:nth-child(2) {
  background: #1F4284;
}

.loadereye span:nth-child(3) {
  background: #604F93;
}

.loadereye span:nth-child(4) {
  background: #512F6C;
}

.loadereye span:nth-child(5) {
  background: #C81C70;
}

.loadereye span:before {
  content: "";
  background: inherit;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  animation: wave 2s ease-out infinite;
}

.loadereye span:nth-child(1):before {
  animation-delay: 0.2s;
}

.loadereye span:nth-child(2):before {
  animation-delay: 0.4s;
}

.loadereye span:nth-child(3):before {
  animation-delay: 0.6s;
}

.loadereye span:nth-child(4):before {
  animation-delay: 0.8s;
}

.loadereye span:nth-child(5):before {
  animation-delay: 1s;
}

@keyframes wave {
  50%, 75% {
    transform: scale(2.5);
  }
  80%, 100% {
    opacity: 0;
  }
}

.geneindex{
  position: relative;
  top: 115px;
  left: -10px;
}

.indexfont {
  color: #45784e;
  text-transform: uppercase;
}

.indexfontlower {
  color: #45784e;
}


</style>
